module.exports = __webpack_public_path__ + "img/device-state-indicator-red.4cf91bc2.svg";